import React from 'react';
import PropTypes from 'prop-types';

import { useContext } from '@hooks';
import { mergeClasses } from '@utils';
import { DrawerContext } from './Drawer';

/**
 * DrawerContent component that serves as a container for the Drawer content.
 *
 * @component DrawerContent
 * @param {Object} props - The properties for the DrawerContent component.
 * @param {React.ReactNode} [props.children] - The child elements of the DrawerContent.
 * @param {string} [props.className] - Optional additional CSS classes to apply to the DrawerContent container.
 * @param {Object} [restProps] - Additional properties to be passed to the DrawerContent container.
 * @returns {ReactElement} The rendered DrawerContent component.
 * @example
 * <DrawerContent>Content Here</DrawerContent>
 */
export default function DrawerContent({ children, className, ...restProps }) {
  useContext(DrawerContext, 'Drawer.Content must be a child of Drawer.');

  if (!children) return null;

  return (
    <div className={mergeClasses('', className)} {...restProps}>
      {children}
    </div>
  );
}

DrawerContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

DrawerContent.defaultProps = {
  children: undefined,
  className: ''
};
